import styled from 'styled-components';
import { containerProps, fontProps, placeholderProps } from '../Properties/Properties';

const Input = styled.input`
    ${containerProps}
    ${fontProps}
    ${placeholderProps}
`;

export default Input;
